export default {
  lang: 'it',
  init: false,
  mobile: false,
  touch: false,
  menu: false,
  menuTrans: false,
  transName: 'default',
  isTrans: false,
  firebase: false,
  routeName: null,
  next: {},
  prev: {},
  goHome: false,
  formStatus: null,
  peopleId: '',
};
